import React from "react";
import { FaTimes } from "react-icons/fa";

const FileViewerModal = ({ isOpen, onClose, selectedFile, getFileViewerURL }) => {
  if (!isOpen || !selectedFile) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-60 z-20">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-[80vh] p-6 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Viewing: {selectedFile.originalName}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <FaTimes className="w-6 h-6" />
          </button>
        </div>
        <div className="flex-1 bg-gray-100 rounded-md overflow-hidden">
          {selectedFile.fileURL ? (
            <iframe
              src={getFileViewerURL(selectedFile)}
              className="w-full h-full border-none"
              title={selectedFile.originalName}
            />
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500">
              Unable to load file preview
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileViewerModal;
